
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Link, Image } from '@ta-interaktiv/contentbricks'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Image className='cbImage noMargin' file={require("images/illus_distance.jpg")} mdxType="Image" />
    <div className='caption'>Das Risiko einer Übertragung steigt durch geringe Distanz und Zeit.</div>
    <h5>
  Drei Übertragungswege stehen im Fokus
    </h5>
    <p>
  <ul>
    <li>Eine Ansteckung kann über einen Oberflächenkontakt erfolgen. Beispielsweise beim Berühren eines Lichtschalters oder einer Türfalle kann das Virus auf die Hand gelangen und von dort beim Berühren von Augen, Mund oder Nasenlöcher eine Infektion auslösen.</li>
    <li>Das neue Coronavirus wird bei engem und längerem persönlichem Kontakt übertragen. Das heisst, bei weniger als 1,5 Metern Abstand während mehr als 15 Minuten, wie das Bundesamt für Gesundheit (BAG) schreibt. Wenn Sie riechen können, was jemand zu Mittag gegessen hat, atmen Sie ein, was er ausatmet, einschliesslich aller Viren in seinem Atem. Die Übertragung erfolgt durch grössere Tröpfchen: Niest, hustet oder spricht die erkrankte Person, können die Viren direkt auf die Schleimhäute von Nase, Mund oder Augen von anderen Menschen gelangen. Die Speicheltröpfchen fliegen wie Geschosse durch die Luft. Treffen sie niemanden, fallen sie nach 1 bis 2 Metern auf den Boden.</li>
    <li>Der dritte Weg ist jener über Aerosole. Ein Aerosol ist ein flüssiges oder festes Teilchen, das in der Luft schwebt. Das kann auch ein Virus sein. Konkret passiert Folgendes: Beim Husten emittiert man unter Umständen Millionen von Viren, beim Sprechen Tausende von Viren in unterschiedlich grossen Tröpfchen. Diese Flüssigkeitstropfen bestehen vor allem aus Wasser und sind typischerweise etwa einen bis über hundert Mikrometer gross, also gerade mal ein Hundertstel bis Zehntel eines Millimeters. Das Wasser verdunstet relativ schnell, das kann in Sekunden bis Minuten passieren, und das Tröpfchen schrumpft. Übrig bleibt irgendwann ein Mix aus dem Virus und irgendwelchen anderen halbflüssigen organischen Bestandteilen, die sich nicht so schnell verflüchtigen, zum Beispiel Speichelmasse. Diese Teilchen verbleiben in der Luft, verteilen sich im Raum und erreichen auch verschiedene Teile der menschlichen Atemwege. Das ist dann wie Feinstaub – ein Begriff, den wir im Deutschen besser kennen.</li>
  </ul>
    </p>
    <p className='readmore' style={{
      marginTop: '2em'
    }}>
  <span className='hint'>Lesen Sie auch</span>
  <Link allowWordWrap icon='file alternate outline icon' href='730872593035' mdxType="Link">
      «Bis Aerosole auf dem Boden landen, kann es Tage dauern» 
  </Link>
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;